import React from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import DeleteModal from "../../../constants/DeleteModal";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import { DeleteIcon, XIcon } from "../../../constants/Icons";


function ViewBoxCash({ isData, onClose ,handleDelete,isBtnLoading,isDeleteModalOpen,setDeleteModalOpen,setDeleteData}) { 
  const showAlert = useShowAlert();
  const {permission,hasPermission}=usePermission();
  const {useEscapeKey}=useContextApi();
  useEscapeKey(onClose)
  const { isUser } = useAuth();
  if (!isData) return null;

  const formattedDate = DateConverter.ISOToDisplayFormat(
    DateConverter.convertToTimeZone(isData?.createdAt, isUser?.timezone)
  ).date;

  const formattedTime = DateConverter.ISOToDisplayFormat(
    DateConverter.convertToTimeZone(isData.createdAt, isUser?.timezone)
  ).time;

  const isCashIn = isData.cmode === "CASHIN";
  const modeClass = isCashIn ? "text-success" : "text-danger";
  const modeIcon = isCashIn
    ? "bx bx-arrow-from-top"
    : "bx bx-arrow-from-bottom";

  const openDeleteModal = (cItem) => {
    if (
      hasPermission("CUSTOMER", "CUSTOMER:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
const DetailItem = ({ icon, label, value }) => (
  <div className="col-md-6">
    <div className="d-flex align-items-center">
      <i className={`${icon} text-primary me-2 fs-5`}></i>
      <div>
        <span className="text-muted fw-semibold  d-block">{label}</span>
        <p className="mb-0 fw-semibold text-break">{value}</p>
      </div>
    </div>
  </div>
);
  return (
    <div>
      <div className={isDeleteModalOpen?"":"modal-backdrop show"}></div>
      <div className="modal show d-block">
        <div className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Box Cash Details</h5>

              <button
                type="button"
                className="btn-close border"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="card shadow-none border radius-15 mb-4">
                <div className="card-body p-0">
                  <div className="p-3">
                    <h4
                      className={`card-title fw-bold text-center mb-3 ${modeClass}`}
                    >
                      <i className={`${modeIcon} me-2`}></i>
                      {isCashIn ? "CASH IN" : "CASH OUT"}
                    </h4>

                    <div className="text-center mb-0">
                      <p className="text-muted mb-1">Transaction Amount</p>
                      <h1 className={`fw-bolder mb-0 ${modeClass}`}>
                      ₹{CurrencyConverter.toCurrency(isData.amount, "INR")}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row g-3">
                <DetailItem
                  icon="bx bx-tag"
                  label="Title"
                  value={isData.title}
                />
                <DetailItem
                  icon="bx bx-time"
                  label="Time"
                  value={formattedTime}
                />
                <DetailItem
                  icon="bx bx-calendar"
                  label="Date"
                  value={formattedDate}
                />
                {isData?.trackid && (
                  <DetailItem
                    icon="bx bx-detail"
                    label="Track ID"
                    value={isData.trackid || "-"}
                  />
                )}
              </div>

              <div className="mt-4 pt-3 border-top">
                <p className="fw-bold mb-0">Description:</p>
                <div className="  p-2">
                  {isData.description || "No detailed description provided."}
                </div>
              </div>

              {isData.denominationData &&
                isData.denominationData.length > 0 && (
                  <div className="mt-4">
                    <p className="fw-bold mb-2">Denominations:</p>
                    <p className="text-warning">
                      Denomination data available .
                    </p>
                  </div>
                )}
            </div>
     {isDeleteModalOpen && (
                      <DeleteModal
                        onClose={() => {setDeleteModalOpen(false)}}
                        onConfirm={handleDelete}
                        isLable={" Boxcash " + isData?.trackmode}
                        isBtnLoading={isBtnLoading}
                      />
                    )}
            <div className="modal-footer d-block ">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon/> Close
              </button>
               <div className="order-actions d-flex align-items-center justify-content-end gap-2">
                 <button                           
                    type="button"
                       className="btn-label-danger shadow-none me-2"
                         onClick={(e) => {
                           e.stopPropagation();
                            openDeleteModal(isData)}}
                              >
                                 <DeleteIcon/> 
                              </button>
                    </div>        
                  </div>
          </div>
        
        </div>
      </div>
    </div>
  );
}

export default ViewBoxCash;
